import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FilterSection from '../FilterSection';
import {FILTER_TYPES} from '../constants';

const filterPropType = PropTypes.shape({
  key: PropTypes.string,
  operator: PropTypes.string,
  value: PropTypes.array,
});

const fieldsPropType = PropTypes.arrayOf(
  PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.oneOf(Object.values(FILTER_TYPES)),
    label: PropTypes.string,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      })
    ),
  })
);

let idCount = 1;

class FilterBuilder extends Component {
  static propTypes = {
    filters: PropTypes.arrayOf(filterPropType),
    fields: fieldsPropType,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    filters: [],
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      filters: (props.filters || []).map((filter) => {
        if (filter.id) {
          return filter;
        }
        return Object.assign({}, filter, { id: idCount++ });
      }),
    };
  }

  componentDidMount() {
    if (this.props.filters.length === 0) {
      this.addFilter();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters)
    ) {
      this.setState({
        filters: this.props.filters.map((filter) => {
          if (filter.id) {
            return filter;
          }
          return Object.assign({}, filter, { id: idCount++ });
        }),
      });
    }
    if (!this.state.filters.length) {
      this.addFilter();
    }
  }

  addFilter() {
    const filter = {
      id: idCount++,
      key: null,
      operator: null,
      value: null,
    };
    const filters = this.state.filters.concat(filter);
    return this.setState({ filters });
  }

  handleChange(index) {
    return (newFilter) => {
      const filters = this.state.filters.map((filter, index2) => {
        if (index2 === index) {
          return newFilter;
        }
        return filter;
      });
      return this.setState({ filters }, () =>
        this.props.onChange(this.state.filters)
      );
    };
  }

  handleDelete(index) {
    return () => {
      const filters = this.state.filters.filter((_filter, index2) => {
        if (index2 === index) {
          return false;
        }
        return true;
      });
      return this.setState({ filters }, () =>
        this.props.onChange(this.state.filters)
      );
    };
  }

  render() {
    return (
      <div className="FilterBuilder">
        {this.state.filters.map((filter, index) => {
          return (
            <FilterSection
              key={filter.id}
              filter={filter}
              fields={this.props.fields}
              onChange={this.handleChange(index)}
              onDelete={this.handleDelete(index)}
              onAdd={this.addFilter.bind(this)}
            />
          );
        })}
      </div>
    );
  }
}

export default FilterBuilder;
